import { render, staticRenderFns } from "./HeaderClip.vue?vue&type=template&id=70f755d8"
import script from "./HeaderClip.vue?vue&type=script&lang=js"
export * from "./HeaderClip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports